<template>
    <div>
        <InternalDossierForm
            :isPatMode="isPatMode"
            :dossierReference="$route.params.reference" />
    </div>
</template>

<script>
import InternalDossierForm from '@/components/internalDossier/InternalDossierForm.vue';

export default {
    name: "InternalDossiersFormView",
    components: { InternalDossierForm },
    props: {
        isPatMode: { type: Boolean, default: false },
        patId: { type: Number, default: null },
        dossierReference: { type: String, default: null }
    },
    data() {
        return {};
    }
};
</script>